module.exports = __webpack_public_path__ + "img/sim.53d2b1da.svg";